/* globals dataLayer */

const footer = {
  init() {
    const footerEl = document.getElementById('footer');
    if (!footerEl) {
      return;
    }
    footerEl.addEventListener('click', (event) => {
      let clickTarget = event.target;
      let counter = 0;

      while (clickTarget.tagName.toLowerCase() !== 'button' && counter < 3) {
        clickTarget = clickTarget.parentElement;
        counter++;
      }

      if (clickTarget.tagName.toLowerCase() === 'button') {
        const eventState = clickTarget.classList.toggle('open')
          ? 'Open'
          : 'Close';

        dataLayer.push({
          event: 'menuState',
          navType: 'Footer',
          navText: clickTarget.textContent.trim(),
          mobileMenuType: 'Mobile Menu',
          mobileMenuState: eventState
        });
      }
    });
  }
};

module.exports = footer;
